import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function PolitiqueConfidentialite() {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 to-white py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <Button variant="ghost" onClick={() => navigate(-1)} className="mb-6">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Retour
        </Button>
        
        <h1 className="text-3xl font-bold text-slate-900 mb-8">Politique de Confidentialité</h1>
        
        <div className="prose prose-slate max-w-none space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-pink-600">1. Responsable du traitement</h2>
            <p>
              <strong>Formation Pressing Sakura</strong><br />
              SIRET : 932 576 515 00013<br />
              Coinaud, 26140 Saint-Rambert-d'Albon, France<br />
              Email : contact@pressing-sakura.fr<br />
              Téléphone : 07 66 83 30 51
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-pink-600">2. Données collectées</h2>
            <p>Nous collectons les données suivantes :</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Identité :</strong> nom, prénom</li>
              <li><strong>Coordonnées :</strong> adresse email, numéro de téléphone, adresse postale</li>
              <li><strong>Réservations :</strong> historique des commandes, préférences</li>
              <li><strong>Compte client :</strong> identifiants de connexion (mot de passe chiffré)</li>
            </ul>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-pink-600">3. Finalités du traitement</h2>
            <p>Vos données sont utilisées pour :</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Gérer vos réservations et livraisons</li>
              <li>Vous contacter concernant vos commandes (SMS, email)</li>
              <li>Gérer votre compte client et programme de fidélité</li>
              <li>Vous envoyer des offres promotionnelles (avec votre consentement)</li>
              <li>Améliorer nos services</li>
            </ul>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-pink-600">4. Base légale</h2>
            <p>Le traitement de vos données repose sur :</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>L'exécution du contrat :</strong> pour gérer vos réservations</li>
              <li><strong>Votre consentement :</strong> pour les communications marketing</li>
              <li><strong>L'intérêt légitime :</strong> pour améliorer nos services</li>
            </ul>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-pink-600">5. Durée de conservation</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Données clients :</strong> 3 ans après la dernière interaction</li>
              <li><strong>Données de réservation :</strong> 5 ans (obligations comptables)</li>
              <li><strong>Données de prospection :</strong> 3 ans après le dernier contact</li>
            </ul>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-pink-600">6. Destinataires des données</h2>
            <p>Vos données peuvent être transmises à :</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Nos prestataires techniques (hébergement, envoi d'emails/SMS)</li>
              <li>Les autorités compétentes en cas d'obligation légale</li>
            </ul>
            <p>Nous ne vendons jamais vos données à des tiers.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-pink-600">7. Vos droits</h2>
            <p>Conformément au RGPD, vous disposez des droits suivants :</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Droit d'accès :</strong> obtenir une copie de vos données</li>
              <li><strong>Droit de rectification :</strong> corriger vos données</li>
              <li><strong>Droit à l'effacement :</strong> supprimer vos données</li>
              <li><strong>Droit d'opposition :</strong> refuser le traitement marketing</li>
              <li><strong>Droit à la portabilité :</strong> récupérer vos données</li>
              <li><strong>Droit de retirer votre consentement</strong> à tout moment</li>
            </ul>
            <p className="mt-4">
              Pour exercer ces droits, contactez-nous à : <strong>contact@pressing-sakura.fr</strong>
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-pink-600">8. Sécurité</h2>
            <p>
              Nous mettons en œuvre des mesures techniques et organisationnelles appropriées 
              pour protéger vos données : chiffrement des mots de passe, connexions sécurisées (HTTPS), 
              accès restreint aux données.
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-pink-600">9. Réclamation</h2>
            <p>
              Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire 
              une réclamation auprès de la CNIL :<br />
              <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-pink-600 underline">
                www.cnil.fr
              </a>
            </p>
          </section>
        </div>
        
        <p className="text-sm text-slate-400 mt-12 text-center">
          Dernière mise à jour : Septembre 2026
        </p>
      </div>
    </div>
  );
}
